export default class Layer{
    constructor( zindex, name, width, height, color, opacity=1, visible=true ){
        this.zindex = zindex;
        this.name = name;
        this.width = width;
        this.height = height;
        this.color = color;
        this.opacity = opacity;
        this.visible = visible;
    }

    setImage( canvas ){
        
        this.canvas = p5App.createGraphics( this.width, this.height );
        this.canvas.pixelDensity( window.pixelDensity );
        this.canvas.image( canvas, 0, 0 );
    }
        

    applyBlur( radius=100, hexAlpha="10"){        
        let ctx = this.canvas.drawingContext;
        ctx.filter = `blur(${radius*window.pixelDensity}px)`;
        this.canvas.drawingContext.globalAlpha = 1;
        ctx.drawImage( ctx.canvas, 0, 0, this.canvas.width*window.pixelDensity, this.canvas.height*window.pixelDensity, 0, 0, this.canvas.width, this.canvas.height);
        ctx.filter = `none`;
        this.canvas.fill( this.color + hexAlpha)
        
        ctx.save();
        ctx.fillStyle = ( this.color + hexAlpha)
        
        ctx.fillRect(0,0,this.width,this.height); 
        ctx.restore()
    }

    remove(){
        this.canvas?.remove();
        delete this.canvas
    }
}